var exports = {
  "kL": "VoiceMessagePlayer.module__container___OEtDdH",
  "Kd": "VoiceMessagePlayer.module__containerActive___OEtDdH",
  "hd": "VoiceMessagePlayer.module__waveformBar___OEtDdH",
  "x5": "VoiceMessagePlayer.module__waveformBarPast___OEtDdH",
  "Rr": "VoiceMessagePlayer.module__playButton___OEtDdH",
  "CJ": "VoiceMessagePlayer.module__playButtonIcon___OEtDdH",
  "S": "VoiceMessagePlayer.module__loadingSpinner___OEtDdH",
  "t0": "VoiceMessagePlayer.module__spin___OEtDdH",
  "FU": "VoiceMessagePlayer.module__waveformContainer___OEtDdH",
  "vE": "VoiceMessagePlayer.module__timestamp___OEtDdH",
  "NS": "VoiceMessagePlayer.module__speedControl___OEtDdH",
  "Wq": "VoiceMessagePlayer.module__volumeControl___OEtDdH",
};

module.exports = exports;
